import { HelmetPage } from 'app/components/HelmetPage';
import MixinitMultipacksNotice from 'app/components/MixinitMultipacksNotice';

export function ReleasesPage() {
  return (
    <>
      <HelmetPage title="Multipacks" />
      <MixinitMultipacksNotice />
    </>
  );
}
